import { Box, styled } from '@mui/material';
import findRoute from 'new/routing/routes';
import React from 'react';
import { useIntl } from 'react-intl';
import { commonLandingPageStyles, landingPageBtn } from '../../styles';
import { LandingPageCommonProps, OfficeInfoNoAuth } from '../../types';
import { Link } from 'react-router';
import { useExternalPatientsStore } from '../../hooks';
import { getPlanTypeFormatMessageProps } from '../../utils';

const Wrapper = styled(Box)(({ theme }) => ({
  ...commonLandingPageStyles,
  paddingTop: 0,
  '.container': {
    width: '90%',
    maxWidth: '1400px',
  },
  [theme.breakpoints.down(993)]: {
    display: 'none',
  },
  hr: {
    borderTop: '1px solid #fff',
    width: '50%',
  },

  '.hero': {
    backgroundSize: 'cover',
    backgroundPosition: 'center right',
    height: '650px',
  },

  '.herotext': {
    marginBottom: '100px',
    color: 'white',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: '2rem',
    borderBottomRightRadius: '10px',
    borderBottomLeftRadius: '10px',
    textAlign: 'center',
    '-webkit-font-smoothing': 'antialiased',

    [theme.breakpoints.up(767)]: {
      width: '60%',
      margin: '0 auto 100px',
    },
    [theme.breakpoints.up(993)]: {
      minWidth: '450px',
      width: '33%',
      margin: '0 0 100px 0',
    },
  },

  '.herotext-title': {
    fontWeight: 'bold',
    fontSize: '4rem',
    lineHeight: '4rem',
    [theme.breakpoints.up(768)]: {
      fontSize: '2rem',
      lineHeight: '2rem',
    },
  },

  '.herotext-subtitle': {
    fontSize: '1.8rem',
    marginTop: '0.8rem',
    lineHeight: '2rem',
  },
  ...landingPageBtn,
}));

type Props = {
  officeData: OfficeInfoNoAuth;
  showJoinButton: boolean;
} & LandingPageCommonProps;

const HeroSection: React.FC<Props> = ({
  officeData,
  showJoinButton,
  colorOneHex,
  colorTwoHex,
  groupInfo,
  bcToken,
}) => {
  const intl = useIntl();
  const { planType } = useExternalPatientsStore();
  if (!officeData.data.externalSignup) return null;

  const groupCode =
    officeData?.data.smBusinessInfo?.smbizBusinessInvites?.groupCode;

  return (
    <Wrapper component="section" className="section-hero">
      <Box
        className="hero"
        sx={{
          backgroundImage: `url("${officeData.data.externalSignup.heroImage}")`,
        }}
      >
        <Box className="container">
          <Box className="herotext" sx={{ backgroundColor: `${colorOneHex}` }}>
            <Box className="herotext-title">
              {intl.formatMessage(
                getPlanTypeFormatMessageProps(
                  'signup.externalLanding.hero.title',
                  planType,
                ),
              )}
            </Box>
            <Box className="herotext-subtitle">
              {intl.formatMessage(
                getPlanTypeFormatMessageProps(
                  'signup.externalLanding.hero.noWorries',
                  planType,
                ),
              )}{' '}
              <br />
              {intl.formatMessage(
                getPlanTypeFormatMessageProps(
                  'signup.externalLanding.hero.joinOurMembershipPlan',
                  planType,
                ),
              )}
            </Box>
            <hr />
            <p>
              {intl.formatMessage(
                getPlanTypeFormatMessageProps(
                  'signup.externalLanding.hero.p1',
                  planType,
                ),
              )}
            </p>
            <p>
              {intl.formatMessage(
                getPlanTypeFormatMessageProps(
                  'signup.externalLanding.hero.p2',
                  planType,
                ),
              )}
            </p>
            {showJoinButton && (
              <Link
                className="btn"
                to={`${findRoute('ExternalPatientSignup').path}?officeId=${
                  officeData.data.id
                }${
                  groupCode == null || groupCode == undefined
                    ? ''
                    : '&groupCode=' + groupCode
                }${
                  bcToken == null || bcToken == undefined
                    ? ''
                    : '&token=' + bcToken
                }${
                  groupInfo == null || groupInfo == undefined
                    ? ''
                    : '&groupInfo=' + groupInfo
                }`}
                style={{
                  backgroundColor: colorTwoHex,
                }}
              >
                {intl.formatMessage({
                  id: 'signup.externalLanding.hero.joinOurMembershipPlan.button',
                })}
              </Link>
            )}
          </Box>
        </Box>
      </Box>
    </Wrapper>
  );
};

export default HeroSection;
